export default {
  "toaster": "_toaster_1mwdg_1",
  "toast": "_toast_1mwdg_1",
  "description": "_description_1mwdg_15",
  "icon": "_icon_1mwdg_16",
  "actionButton": "_actionButton_1mwdg_23",
  "content": "_content_1mwdg_40",
  "closeButton": "_closeButton_1mwdg_44",
  "success": "_success_1mwdg_57",
  "error": "_error_1mwdg_61"
};import "ni:sha-256;ag1tcLYv3-WHAkRBxkORf1-YARC3C7Fr9ATs2DTVX9Q";